var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_293691",
    "data-name": "Group 293691",
    transform: "translate(-244 -980)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 18,
    height: 18,
    transform: "translate(244 980)",
    fill: "#ff13dc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "tiktok-svgrepo-com",
    d: "M17.31,6.036A4.128,4.128,0,0,1,14.063,2.38V2H11.1V13.776a2.494,2.494,0,0,1-4.48,1.5h0a2.493,2.493,0,0,1,2.742-3.884V8.378a5.451,5.451,0,1,0,4.705,5.4V7.76a7.047,7.047,0,0,0,4.111,1.314V6.126A4.161,4.161,0,0,1,17.31,6.036Z",
    transform: "translate(241.84 978)",
    fill: "#222"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.42914439a8464d66704dcb8d824d9fd7.svg";
export { ForwardRef as ReactComponent };